import auth from '../utils/auth'
import rest from '../utils/rest'

const tokenRequest = {
  scopes: ['openid', 'profile', 'User.Read'],
  forceRefresh: true // set this to "true" if you would like to skip a cached token and go to the server
};

export default {
  async getUserProfile() {
    const url = 'https://graph.microsoft.com/beta/me/';
    const options = await auth.getOptions(tokenRequest, 'GET');

    return await rest.call(url, options);
  },
  async getAppRoleAssignments() {
    //Use Enterprise Application TDM object Id to app role assignments
    const url = 'https://graph.microsoft.com/beta/me/appRoleAssignments?$filter=resourceId eq a4f67641-d405-442c-b777-ceb089852be4';
    const options = await auth.getOptions(tokenRequest, 'GET');
    return await rest.call(url, options);
  }
}